var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKids({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_117_1913",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.4 23.4001V0.600061H0.6V23.4001H23.4Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.2
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_117_1913)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.79846 13.0672C6.79846 12.2783 7.43798 11.6388 8.22691 11.6388C9.0158 11.6388 9.65532 12.2783 9.65532 13.0672",
    stroke: "#3936EF",
    strokeWidth: 1.2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9411 13.0672C13.9411 12.2783 14.5806 11.6388 15.3695 11.6388C16.1584 11.6388 16.7979 12.2783 16.7979 13.0672",
    stroke: "#3936EF",
    strokeWidth: 1.2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.33675 15.924C9.83367 16.7662 10.7498 17.3315 11.7984 17.3315C12.847 17.3315 13.7631 16.7662 14.26 15.924",
    stroke: "#3936EF",
    strokeWidth: 1.2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7973 12.8183C21.7973 13.9875 20.8609 14.938 19.6967 14.96C18.7557 18.4397 15.5759 21.0001 11.7983 21.0001C8.02061 21.0001 4.84084 18.4397 3.89985 14.96C2.73565 14.938 1.79922 13.9875 1.79922 12.8183C1.79922 12.2266 2.03904 11.691 2.42655 11.3031C2.80535 10.9247 3.3248 10.6874 3.89985 10.6766C4.84084 7.19684 8.02061 4.6365 11.7983 4.6365C15.5759 4.6365 18.7557 7.19684 19.6967 10.6766C20.2717 10.6874 20.7912 10.9247 21.17 11.3031C21.5575 11.691 21.7973 12.2266 21.7973 12.8183Z",
    stroke: "#3936EF",
    strokeWidth: 1.2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.13624 7.29896C9.13624 8.76939 10.3282 9.9614 11.7987 9.9614C13.2691 9.9614 14.4612 8.76939 14.4612 7.29896C14.4612 5.82852 13.2691 4.63652 11.7987 4.63652H11.3814C10.0341 4.63652 8.94182 3.54426 8.94182 2.19688",
    stroke: "#3936EF",
    strokeWidth: 1.2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7973 4.63647H8.52322C7.17584 4.63647 6.08362 3.54422 6.08362 2.19688",
    stroke: "#3936EF",
    strokeWidth: 1.2,
    strokeMiterlimit: 10
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKids);
export default __webpack_public_path__ + "static/media/Kids.7b9cb487c8ac4a265146ea22db32e10d.svg";
export { ForwardRef as ReactComponent };